import { useEffect, useState } from 'react';
import { videoBackground } from '@lib/videoBackgrounds/backgrounds';

export const useVideoBackground = () => {
  const [backgroundId, setBackgroundId] = useState(videoBackground.backgroundId); // defaults to NO_BACKGROUND ('None')
  const [isLoading, setIsLoading] = useState(videoBackground.isLoading); // defaults to false

  useEffect(() => {
    videoBackground.on('changed', setBackgroundId);
    videoBackground.on('loadingChanged', setIsLoading);

    return () => {
      videoBackground.off('changed', setBackgroundId);
      videoBackground.off('loadingChanged', setIsLoading);
    };
  }, []);

  return {
    backgroundId,
    isLoading,
    setBackground: (id: string) => videoBackground.setBackground(id)
  };
};

export default useVideoBackground;
